/** @jsxImportSource @emotion/react */
import { createFetchContext } from '../contextFetch/FetchContext'
import { TenantThemeType } from './types'

export default createFetchContext<TenantThemeType>()
